import { render, staticRenderFns } from "./BtnBlobControls.vue?vue&type=template&id=fe326d0a&scoped=true"
import script from "./BtnBlobControls.vue?vue&type=script&lang=js"
export * from "./BtnBlobControls.vue?vue&type=script&lang=js"
import style0 from "./BtnBlobControls.vue?vue&type=style&index=0&id=fe326d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe326d0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
